import { useCallback } from 'react'
import { useLocation, resolvePath } from 'react-router-dom'
import { ROUTER_BASE_NAME } from '@/configs/env'

export function useRouteResolver() {
  const { pathname } = useLocation()

  const resolveUrl = useCallback(
    (/** @type {string} */ target) => {
      const { pathname: targetRoute } = resolvePath(target, pathname)
      return {
        targetRoute,
        targetUrl: `${ROUTER_BASE_NAME}${targetRoute}`,
      }
    },
    [pathname],
  )

  return { resolveUrl }
}
